/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutputGeoTraceParams
 */
export interface OutputGeoTraceParams {
    /**
     * 
     * @type {number}
     * @memberof OutputGeoTraceParams
     */
    alphaAnchor?: number;
    /**
     * 
     * @type {number}
     * @memberof OutputGeoTraceParams
     */
    alphaChain?: number;
    /**
     * 
     * @type {number}
     * @memberof OutputGeoTraceParams
     */
    alphaCorridor?: number;
    /**
     * 
     * @type {number}
     * @memberof OutputGeoTraceParams
     */
    beamWidth?: number;
    /**
     * 
     * @type {number}
     * @memberof OutputGeoTraceParams
     */
    candidateLimit?: number;
    /**
     * 
     * @type {number}
     * @memberof OutputGeoTraceParams
     */
    coreLinkKm?: number;
    /**
     * Параметри консенсус-ядра: поріг «майже точного» збігу назви, радіус зчеплення опорних
     * точок у ланцюг і мінімум різних токенів, за якого група вважається консенсусом.
     * @type {number}
     * @memberof OutputGeoTraceParams
     */
    coreMinScore?: number;
    /**
     * 
     * @type {number}
     * @memberof OutputGeoTraceParams
     */
    coreMinTokens?: number;
    /**
     * 
     * @type {number}
     * @memberof OutputGeoTraceParams
     */
    corridorSlackKm?: number;
    /**
     * 
     * @type {number}
     * @memberof OutputGeoTraceParams
     */
    minScore?: number;
}

/**
 * Check if a given object implements the OutputGeoTraceParams interface.
 */
export function instanceOfOutputGeoTraceParams(value: object): boolean {
    return true;
}

export function OutputGeoTraceParamsFromJSON(json: any): OutputGeoTraceParams {
    return OutputGeoTraceParamsFromJSONTyped(json, false);
}

export function OutputGeoTraceParamsFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputGeoTraceParams {
    if (json == null) {
        return json;
    }
    return {
        
        'alphaAnchor': json['alphaAnchor'] == null ? undefined : json['alphaAnchor'],
        'alphaChain': json['alphaChain'] == null ? undefined : json['alphaChain'],
        'alphaCorridor': json['alphaCorridor'] == null ? undefined : json['alphaCorridor'],
        'beamWidth': json['beamWidth'] == null ? undefined : json['beamWidth'],
        'candidateLimit': json['candidateLimit'] == null ? undefined : json['candidateLimit'],
        'coreLinkKm': json['coreLinkKm'] == null ? undefined : json['coreLinkKm'],
        'coreMinScore': json['coreMinScore'] == null ? undefined : json['coreMinScore'],
        'coreMinTokens': json['coreMinTokens'] == null ? undefined : json['coreMinTokens'],
        'corridorSlackKm': json['corridorSlackKm'] == null ? undefined : json['corridorSlackKm'],
        'minScore': json['minScore'] == null ? undefined : json['minScore'],
    };
}

export function OutputGeoTraceParamsToJSON(value?: OutputGeoTraceParams | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'alphaAnchor': value['alphaAnchor'],
        'alphaChain': value['alphaChain'],
        'alphaCorridor': value['alphaCorridor'],
        'beamWidth': value['beamWidth'],
        'candidateLimit': value['candidateLimit'],
        'coreLinkKm': value['coreLinkKm'],
        'coreMinScore': value['coreMinScore'],
        'coreMinTokens': value['coreMinTokens'],
        'corridorSlackKm': value['corridorSlackKm'],
        'minScore': value['minScore'],
    };
}

